<script>
import loading from "@/components/elements/AppLoading.vue";
import AppLoading from "@/components/elements/AppLoading.vue";
import {mapActions, mapGetters} from "vuex";
import Table from "@/components/layouts/Table.vue";
import {permissionMixin} from "@/mixins/permissionMixins";
import {DataService} from "@/services/DataService";

export default {
  name: "AccidentIncidentVesselLoss",
  mixins:[permissionMixin],
  components: {Table, AppLoading, loading},
  data() {
    const startYear = 2011;
    const currentYear = new Date().getFullYear();
    const six_years = Array.from({ length: 6 }, (_, i) => currentYear - 5 + i);
    return {
      six_years,
      selectLossFilterIndex : 0,
      selectedYear : new Date().getFullYear(),
      years : Array.from({ length: currentYear - startYear + 1 }, (_, i) => startYear + i).reverse(),
      amountLossFilter : [
        {
          text : '> 0 to 1000',
          total_loss_from : null,
          total_loss_to : 1000,
        },
        {
          text : '1,001 to 10,000',
          total_loss_from : 1001,
          total_loss_to : 10000,
        },
        {
          text : '10,001 to 100,000',
          total_loss_from : 10001,
          total_loss_to : 100000,
        },
        {
          text : '100,001 to 1,000,000',
          total_loss_from : 100001,
          total_loss_to : 1000000,
        },
        {
          text : '1,000,001 to 10,000,000',
          total_loss_from : 1000001,
          total_loss_to : 10000000,
        },
        {
          text : '10,000,001 to 100,000,000',
          total_loss_from : 10000001,
          total_loss_to : 100000000,
        },
        {
          text : '100,000,001 to 1,000,000,000',
          total_loss_from : 100000001,
          total_loss_to : 1000000000,
        },
        {
          text : '> 1,000,000,000',
          total_loss_from : 1000000001,
          total_loss_to : null,
        }
      ],
      loading : true,
      dataToView : {
        vessel_name : '',
        total_loss_to_usd : 0,
        accident_incidents : []
      },
      chartOptions: {
        chart: {
          type: 'bar',
          events:{
            xAxisLabelClick: function(event, chartContext, config){
              if (this.isAllowed('menu.reports.accident-incident') === false) {
                return;
              }
              this.graphModalData = {
                year : null,
                current_series_index : config.labelIndex,
                event_category : this.chartOptions.xaxis.categories[config.labelIndex],
                data : []
              }
              this.getGraphModalData();
              $('#graph_loss_info_modal').modal('show');
            }.bind(this)
          }
        },
        title: {
          text: 'YEARLY TOTAL LOSS PER EVENT CATEGORY',
          align: 'center',
        },
        plotOptions: {
          bar: {
            horizontal: true,
            vertical: true,
            dataLabels: {
              position: 'top',
            },
          }
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          colors: ['#000']
        },
        tooltip: {
          followCursor : true,
          shared: true,
          intersect: false
        },
        colors: ['#bfbfbf', '#a6a6a6', '#ffd966', '#f7caac', '#f4b083', '#ff0000'],
        grid: {
          borderColor: '#e9e9e9',
          position: 'front',
          xaxis: {
            lines: {
              show: true,
            }
          }
        },
        xaxis: {
          categories: [],
        },
      },
      series : [],
      graphModalData : {
        year : null,
        event_category : '',
        data : [],
        current_series_index : null
      }
    }
  },
  methods : {
    ...mapActions([
      'getDashboardAccidentIncidentLossReport',
      'getEventOneKeys'
    ]),
    async fetchDashboardAccidentIncidentLossReport() {
      this.loading = true;
      await this.getDashboardAccidentIncidentLossReport();
      this.loading = false;
    },
    viewVesselLossInfo(data) {
      $('#vessel_loss_info_modal').modal('show');
      this.dataToView = data;
    },
    async showReportNewTab (reportId) {
      if (this.isAllowed('menu.reports.accident-incident') === false) {
        return;
      }
      const route= this.$router.resolve(
        {
          name: 'Loss',
          params: {
            id: reportId,
          },
        },
      )
      window.open(route.href,'_blank')
    },
    setSelectLossFilterIndex() {
      for (let counter = 0; counter < this.amountLossFilter.length; counter++) {
        this.selectLossFilterIndex = counter;
        if (this.filteredDataForTable.length > 0) {
          break;
        }
      }

    },
    prepareSeriesData() {
      this.series = this.six_years.map(year => {
        const data = this.eventOneKeys.map(eventOneItem => {
          return this.vesselAccidentIncidentData
            .map(vessel => vessel.accident_incidents)
            .flat()
            .filter(accident => {
              if (!accident.event_date) return false;
              return new Date(accident.event_date).getFullYear() === year && accident.event?.event_one?.id === eventOneItem.id
            }) ;
        });
        return {
          name: year,
          meta_data : data,
          data : data.map(item => {
            return DataService.truncate(parseFloat(item.map(subItem => subItem.loss.total_loss_to_usd).reduce((acc, curr) => acc + curr, 0)))
          })
        }
      });
    },
    getGraphModalData() {
      this.graphModalData.data = this.series.map(seriesItem => {
        const data = seriesItem.meta_data[this.graphModalData.current_series_index];
        if (this.graphModalData.year) {
          return data.filter(item => {
            return new Date(item.event_date).getFullYear() === this.graphModalData.year;
          })
        }
        return seriesItem.meta_data[this.graphModalData.current_series_index]
      }).flat();
    }
  },
  async created() {
    await this.getEventOneKeys();
    this.chartOptions.xaxis.categories = this.eventOneKeys.map((item, index) => `${String.fromCharCode(65 + index)} ) ${item.name.toUpperCase()}`)
    if (this.vesselAccidentIncidentData.length === 0) {
     await this.fetchDashboardAccidentIncidentLossReport();
    }
    this.setSelectLossFilterIndex()
    await this.prepareSeriesData();
    this.loading = false;

  },
  computed : {
    DataService() {
      return DataService
    },
    ...mapGetters([
      'vesselAccidentIncidentData',
      'eventOneKeys',
    ]),
    selectLossFilter() {
      return this.amountLossFilter[this.selectLossFilterIndex];
    },
    filteredDataForTable() {
      return this.vesselAccidentIncidentData.map(vessel => {
        return {
          id : vessel.id,
          name : vessel.name,
          total_loss_to_usd : vessel.total_loss_to_usd,
          management_office : vessel.management_office,
          accident_incidents : vessel.accident_incidents.filter(accident_incident => {
            const date = new Date(accident_incident.event_date);
            return parseInt(this.selectedYear) === date.getFullYear();
          }),

        }
      }).filter(vessel => {
        const hasAccidentIncidents = vessel.accident_incidents.length > 0;

        if (this.selectLossFilter.total_loss_from === null && this.selectLossFilter.total_loss_to === null) {
          return hasAccidentIncidents
        }

        if (this.selectLossFilter.total_loss_from !== null && this.selectLossFilter.total_loss_to === null) {
          return hasAccidentIncidents && vessel.total_loss_to_usd >= this.selectLossFilter.total_loss_from;
        }

        if (this.selectLossFilter.total_loss_from === null && this.selectLossFilter.total_loss_to !== null) {
          return hasAccidentIncidents && vessel.total_loss_to_usd <= this.selectLossFilter.total_loss_to;
        }

        return hasAccidentIncidents && vessel.total_loss_to_usd >= this.selectLossFilter.total_loss_from && vessel.total_loss_to_usd <= this.selectLossFilter.total_loss_to;

      });
    },
  }
}
</script>

<template>
  <div class="row">
    <div class="col-12 text-center col-lg-12">
      <div class="row no-gutters mb-4">
        <div class="col-7 pl-4">
          <div class="row">
            <div class="col-md-auto pr-0">
              <label class="col-form-label pr-2 font-weight-bold">Amount Loss: </label>
            </div>
            <div class="col-md-auto pl-0">
              <select class="form-inline form-control form-control-sm form-control-xs"
                      v-model="selectLossFilterIndex"
                      :disabled="loading"
              >
                <option v-for="(loss, index) in amountLossFilter" :value="index">{{ loss.text }}</option>
              </select>
            </div>

            <div class="col-md-auto pr-0">
              <label class="col-form-label pr-2 font-weight-bold">Year: </label>
            </div>
            <div class="col-md-auto pl-0">
              <select name="" id="" class="form-inline form-control form-control-sm form-control-xs"
                      v-model="selectedYear"
                      :disabled="loading"
              >
                <option v-for="year in years">{{ year }}</option>
              </select>
            </div>
          </div>
        </div>
        <table class="table table-sm table-bordered small mt-1 e-tbl mb-0">
          <thead>
          <tr>
            <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9;" scope="col">#</th>
            <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9;" scope="col">VESSEL NAME</th>
            <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9;" scope="col">MANAGEMENT OFFICE</th>
            <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9;" scope="col">TOTAL LOSS</th>
            <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9;" scope="col">ACTION</th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="loading">
            <td colspan="100%">
              <app-loading :message="'Fetching with CMS data, Please wait...'"></app-loading>
            </td>
          </tr>
          <template v-else>
            <template v-if="filteredDataForTable.length === 0">
              <tr>
                <td colspan="100%" class="align-middle text-center font-weight-bold bg-secondary text-white">NO RESULTS FOUND</td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="(data, index) in filteredDataForTable" class="list-data" @dblclick="viewVesselLossInfo(data)">
                <td>{{ index + 1 }}</td>
                <td>{{ data?.name }}</td>
                <td class="text-uppercase">{{ data?.management_office?.name }}</td>
                <td>USD: {{ Number(data?.total_loss_to_usd)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                <td>
                  <button class="e-btn e-btn-blue e-btn-sm e-text-white"
                          @click="viewVesselLossInfo(data)"
                  >
                    <font-awesome-icon icon="eye" />
                    View
                  </button>
                </td>
              </tr>
            </template>
          </template>
          </tbody>
        </table>
      </div>

      <div class="card mb-4">
        <div class="card-body">
          <template v-if="loading">
            <app-loading
              :message="'Preparing graph of yearly total loss per event category, please wait...'"
            />
          </template>
          <apexchart
            v-else
            type="bar"
            height="600"
            :options="chartOptions"
            :series="series"
            ref="chart"
          />
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <template v-if="loading">
            <app-loading
              :message="'Preparing table data of yearly total loss per event category, please wait...'"
            />
          </template>
          <template v-else >
            <div class="row no-gutters">
              <div class="col text-left">
                <h5 class="e-text-red-light-1">Accident / Incident Loss Data</h5>
              </div>
            </div>
            <table class="table text-center table-bordered table-sm text-dark mb-1">
              <thead>
              <tr class="text-center">
                <th class="lead bg-ffd966">Description</th>
                <th v-for=" (year,index) in six_years " :class="{
        'lead bg-bfbfbf' : index === 0,
        'lead bg-a6a6a6' : index === 1,
        'lead bg-ffd966' : index === 2,
        'lead bg-f7caac' : index === 3,
        'lead bg-f4b083' : index === 4,
        'lead bg-ff0000' : index === 5,
      }"> {{year}}</th>
              </tr>
              </thead>
                        <tbody>
                        <tr v-for="(event, index) in chartOptions.xaxis.categories" :class="{'hr-line' : index === chartOptions.xaxis.categories.length - 1}">
                          <td :class="{'hr-line' : index === chartOptions.xaxis.categories.length - 1}">{{event}}</td>
                          <td :class="{'hr-line' : index === chartOptions.xaxis.categories.length - 1}" v-for="(year) in six_years">
                            {{ series.filter(seriesItem => seriesItem.name === year)[0]?.data[index]}}
                          </td>
                        </tr>

                        <tr>
                          <td><h6 class="font-weight-bold text-danger m-0 p-0">SUMMARY</h6></td>
                          <template v-for="(year) in six_years">
                            <td><h6 class="font-weight-bold text-danger m-0 p-0">
                              {{ DataService.truncate(series.filter(seriesItem => seriesItem.name === year)[0]?.data.reduce((acc, curr) => acc + curr, 0)) }}
                            </h6></td>
                          </template>
                        </tr>
                        </tbody>
            </table>
          </template>
        </div>


      </div>


    </div>

    <div class="modal fade" id="graph_loss_info_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xxl modal-dialog-centered" style="max-width: 80vw;">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title mr-2" id="eventModalLabel">
              {{ graphModalData.event_category }}
            </h5>
            <select name="year" id="year" v-model="graphModalData.year" class="form-control form-control-sm w-auto" @change="getGraphModalData">
              <option :value="null">{{Math.min(...six_years)}}-{{Math.max(...six_years)}}</option>
              <option :value="year" v-for="year in six_years">
                {{year}}
              </option>
            </select>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table e-tbl">
                  <thead>
                  <tr>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9; min-width: 5%;">#</th>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9; min-width: 5%;">Vessel Name</th>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9; min-width: 150px">Report Title</th>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9; min-width: 90px;">Event Date</th>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9; min-width: 110px;">Personnel</th>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9; min-width: 150px;">Hull and Machinery</th>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9; min-width: 110px;">Cargo Damage</th>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9; min-width: 110px;">Environmental</th>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9; min-width: 110px;">Third Party</th>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9; min-width: 110px;">Total Amount in USD</th>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9;">Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-if="graphModalData?.data.length === 0">
                    <tr>
                      <td colspan="100%" class="align-middle text-center font-weight-bold bg-secondary text-white">NO RESULTS FOUND</td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr v-for="(accidentIncident, index) in graphModalData.data" class="list-data" @dblclick="showReportNewTab(accidentIncident.id)">
                      <td class="text-center align-middle p-1">{{ index + 1 }}</td>
                      <td class="text-center align-middle p-1">{{ accidentIncident.vessel?.name }}</td>
                      <td class="text-center align-middle p-1">{{ accidentIncident.title }}</td>
                      <td class="text-center align-middle p-1">{{ accidentIncident?.formatted_event_date }}</td>
                      <td class="text-center align-middle p-1">
                        <template v-if="accidentIncident?.loss?.accident_incident_loss_personnels.length > 1">
                          <div v-for="(personnel, index) in accidentIncident?.loss?.accident_incident_loss_personnels">
                            <table class="table mb-2">
                              <tr v-if="personnel?.currency_code !== 'USD'">
                                <td class="text-center align-middle p-1" rowspan="2">#{{ index + 1}}</td>
                                <td class="text-center align-middle p-1">{{ personnel?.currency_code }}</td>
                                <td class="text-center align-middle p-1">{{ Number(personnel?.personnel_costs)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                              </tr>
                              <tr>
                                <td class="text-center align-middle p-1" v-if="personnel?.currency_code === 'USD'">#{{ index + 1}}</td>
                                <td class="text-center align-middle p-1">{{ personnel?.currency_code === 'USD' ? '' : 'CONVERTED TO' }} USD</td>
                                <td class="text-center align-middle p-1"><span class="font-weight-bold">{{ Number(personnel?.personnel_costs_to_usd)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span></td>
                              </tr>
                            </table>
                          </div>
                          <table style="border: none; border-top: 2px solid black">
                            <tr style="border: none">
                              <td class="text-center align-middle p-1" style="border: none">TOTAL IN USD:</td>
                              <td class="text-center align-middle p-1" style="border: none"><span class="font-weight-bold">{{ accidentIncident?.loss?.loss_personnel_total_cost_to_usd }}</span></td>
                            </tr>
                          </table>
                        </template>
                        <template v-else-if="accidentIncident?.loss?.accident_incident_loss_personnels.length === 1">
                          <div v-for="personnel in accidentIncident?.loss?.accident_incident_loss_personnels">
                            <template v-if="personnel?.currency_code === 'USD'">
                              {{ personnel?.currency_code }}: <span class="font-weight-bold">{{ Number(personnel?.personnel_costs)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                            </template>
                            <table class="table mb-2" v-else>
                              <tr v-if="personnel?.currency_code !== 'USD'">
                                <td class="text-center align-middle p-1">{{ personnel?.currency_code }}</td>
                                <td class="text-center align-middle p-1">{{ Number(personnel?.personnel_costs)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                              </tr>
                              <tr>
                                <td class="text-center align-middle p-1">{{ personnel?.currency_code === 'USD' ? '' : 'CONVERTED TO' }} USD</td>
                                <td class="text-center align-middle p-1"><span class="font-weight-bold">{{ Number(personnel?.personnel_costs_to_usd)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span></td>
                              </tr>
                            </table>
                          </div>
                        </template>
                        <template v-else>
                          0
                        </template>
                      </td>
                      <td class="text-center align-middle p-1">
                        <template v-if="accidentIncident?.loss?.hm_cost">
                          <template v-if="accidentIncident?.loss?.hm_currency_code === 'USD'">
                            {{ accidentIncident?.loss?.hm_currency_code }}: <span class="font-weight-bold">{{ Number(accidentIncident?.loss?.hm_cost)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                          </template>
                          <table class="table mb-2" v-else>
                            <tr>
                              <td class="text-center align-middle p-1">{{ accidentIncident?.loss?.hm_currency_code }}</td>
                              <td class="text-center align-middle p-1">{{ Number(accidentIncident?.loss?.hm_cost)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                            </tr>
                            <tr>
                              <td class="text-center align-middle p-1">{{ accidentIncident?.loss?.hm_currency_code === 'USD' ? '' : 'CONVERTED TO' }} USD</td>
                              <td class="text-center align-middle p-1">
                                <span class="font-weight-bold">{{ Number(accidentIncident?.loss?.hm_cost_to_usd)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                              </td>
                            </tr>
                          </table>
                        </template>
                        <template v-else>
                          0
                        </template>
                      </td>
                      <td class="text-center align-middle p-1">
                        <template v-if="accidentIncident?.loss?.cd_cost">
                          <template v-if="accidentIncident?.loss?.cd_currency_code === 'USD'">
                            {{ accidentIncident?.loss?.cd_currency_code }}: <span class="font-weight-bold">{{ Number(accidentIncident?.loss?.cd_cost)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                          </template>
                          <table class="table mb-2" v-else>
                            <tr>
                              <td class="text-center align-middle p-1">{{ accidentIncident?.loss?.cd_currency_code }}</td>
                              <td class="text-center align-middle p-1">{{ Number(accidentIncident?.loss?.cd_cost)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                            </tr>
                            <tr>
                              <td class="text-center align-middle p-1">{{ accidentIncident?.loss?.cd_currency_code === 'USD' ? '' : 'CONVERTED TO' }} USD</td>
                              <td class="text-center align-middle p-1">
                                <span class="font-weight-bold">{{ Number(accidentIncident?.loss?.cd_cost_to_usd)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                              </td>
                            </tr>
                          </table>
                        </template>
                        <template v-else>
                          0
                        </template>
                      </td>
                      <td class="text-center align-middle p-1">
                        <template v-if="accidentIncident?.loss?.e_cost">
                          <template v-if="accidentIncident?.loss?.e_currency_code === 'USD'">
                            {{ accidentIncident?.loss?.e_currency_code }}: <span class="font-weight-bold">{{ Number(accidentIncident?.loss?.e_cost)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                          </template>
                          <table class="table mb-2" v-else>
                            <tr>
                              <td class="text-center align-middle p-1">{{ accidentIncident?.loss?.e_currency_code }}</td>
                              <td class="text-center align-middle p-1">{{ Number(accidentIncident?.loss?.e_cost)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                            </tr>
                            <tr>
                              <td class="text-center align-middle p-1">{{ accidentIncident?.loss?.e_currency_code === 'USD' ? '' : 'CONVERTED TO' }} USD</td>
                              <td class="text-center align-middle p-1">
                                <span class="font-weight-bold">{{ Number(accidentIncident?.loss?.e_cost_to_usd)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                              </td>
                            </tr>
                          </table>
                        </template>
                        <template v-else>
                          0
                        </template>
                      </td>
                      <td class="text-center align-middle p-1">
                        <template v-if="accidentIncident?.loss?.tp_cost">
                          <template v-if="accidentIncident?.loss?.tp_currency_code === 'USD'">
                            {{ accidentIncident?.loss?.tp_currency_code }}: <span class="font-weight-bold">{{ Number(accidentIncident?.loss?.tp_cost)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                          </template>
                          <table class="table mb-2" v-else>
                            <tr>
                              <td class="text-center align-middle p-1">{{ accidentIncident?.loss?.tp_currency_code }}</td>
                              <td class="text-center align-middle p-1">{{ Number(accidentIncident?.loss?.tp_cost)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                            </tr>
                            <tr>
                              <td class="text-center align-middle p-1">{{ accidentIncident?.loss?.tp_currency_code === 'USD' ? '' : 'CONVERTED TO' }} USD</td>
                              <td class="text-center align-middle p-1">
                                <span class="font-weight-bold">{{ Number(accidentIncident?.loss?.tp_cost_to_usd)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                              </td>
                            </tr>
                          </table>
                        </template>
                        <template v-else>
                          0
                        </template>
                      </td>
                      <td class="text-center align-middle p-1">
                        <span class="font-weight-bold">{{ Number(accidentIncident?.loss?.total_loss_to_usd)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                      </td>
                      <td class="text-center align-middle p-0">
                        <button class="e-btn e-btn-blue e-btn-sm e-text-white"
                                v-if="isAllowed('menu.reports.accident-incident') === true"
                                @click="showReportNewTab(accidentIncident.id)"
                        >
                          <font-awesome-icon icon="eye" />
                          View
                        </button>
                      </td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="modal fade" id="vessel_loss_info_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xxl modal-dialog-centered" style="max-width: 80vw;">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold">{{ dataToView?.name }} </h5>
            <h6 style="font-size: 14px" class="mt-1 pl-1 modal-title text-danger font-weight-bold text-uppercase"> (Total Loss Amount (Converted to USD: {{ Number(dataToView.total_loss_to_usd)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}))</h6>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table e-tbl">
                  <thead>
                  <tr>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9; min-width: 5%;">#</th>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9; min-width: 150px">Report Title</th>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9; min-width: 90px;">Event Date</th>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9; min-width: 110px;">Personnel</th>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9; min-width: 150px;">Hull and Machinery</th>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9; min-width: 110px;">Cargo Damage</th>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9; min-width: 110px;">Environmental</th>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9; min-width: 110px;">Third Party</th>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9; min-width: 110px;">Total Amount in USD</th>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9;">Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-if="dataToView.accident_incidents.length === 0">
                    <tr>
                      <td colspan="100%" class="align-middle text-center font-weight-bold bg-secondary text-white">NO RESULTS FOUND</td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr v-for="(accidentIncident, index) in dataToView.accident_incidents" class="list-data" @dblclick="showReportNewTab(accidentIncident.id)">
                      <td class="text-center align-middle p-1">{{ index + 1 }}</td>
                      <td class="text-center align-middle p-1">{{ accidentIncident.title }}</td>
                      <td class="text-center align-middle p-1">{{ accidentIncident?.formatted_event_date }}</td>
                      <td class="text-center align-middle p-1">
                        <template v-if="accidentIncident?.loss?.accident_incident_loss_personnels.length > 1">
                          <div v-for="(personnel, index) in accidentIncident?.loss?.accident_incident_loss_personnels">
                            <table class="table mb-2">
                              <tr v-if="personnel?.currency_code !== 'USD'">
                                <td class="text-center align-middle p-1" rowspan="2">#{{ index + 1}}</td>
                                <td class="text-center align-middle p-1">{{ personnel?.currency_code }}</td>
                                <td class="text-center align-middle p-1">{{ Number(personnel?.personnel_costs)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                              </tr>
                              <tr>
                                <td class="text-center align-middle p-1" v-if="personnel?.currency_code === 'USD'">#{{ index + 1}}</td>
                                <td class="text-center align-middle p-1">{{ personnel?.currency_code === 'USD' ? '' : 'CONVERTED TO' }} USD</td>
                                <td class="text-center align-middle p-1"><span class="font-weight-bold">{{ Number(personnel?.personnel_costs_to_usd)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span></td>
                              </tr>
                            </table>
                          </div>
                          <table style="border: none; border-top: 2px solid black">
                            <tr style="border: none">
                              <td class="text-center align-middle p-1" style="border: none">TOTAL IN USD:</td>
                              <td class="text-center align-middle p-1" style="border: none"><span class="font-weight-bold">{{ accidentIncident?.loss?.loss_personnel_total_cost_to_usd }}</span></td>
                            </tr>
                          </table>
                        </template>
                        <template v-else-if="accidentIncident?.loss?.accident_incident_loss_personnels.length === 1">
                          <div v-for="personnel in accidentIncident?.loss?.accident_incident_loss_personnels">
                            <template v-if="personnel?.currency_code === 'USD'">
                              {{ personnel?.currency_code }}: <span class="font-weight-bold">{{ Number(personnel?.personnel_costs)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                            </template>
                            <table class="table mb-2" v-else>
                              <tr v-if="personnel?.currency_code !== 'USD'">
                                <td class="text-center align-middle p-1">{{ personnel?.currency_code }}</td>
                                <td class="text-center align-middle p-1">{{ Number(personnel?.personnel_costs)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                              </tr>
                              <tr>
                                <td class="text-center align-middle p-1">{{ personnel?.currency_code === 'USD' ? '' : 'CONVERTED TO' }} USD</td>
                                <td class="text-center align-middle p-1"><span class="font-weight-bold">{{ Number(personnel?.personnel_costs_to_usd)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span></td>
                              </tr>
                            </table>
                          </div>
                        </template>
                        <template v-else>
                          0
                        </template>
                      </td>
                      <td class="text-center align-middle p-1">
                        <template v-if="accidentIncident?.loss?.hm_cost">
                          <template v-if="accidentIncident?.loss?.hm_currency_code === 'USD'">
                            {{ accidentIncident?.loss?.hm_currency_code }}: <span class="font-weight-bold">{{ Number(accidentIncident?.loss?.hm_cost)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                          </template>
                          <table class="table mb-2" v-else>
                            <tr>
                              <td class="text-center align-middle p-1">{{ accidentIncident?.loss?.hm_currency_code }}</td>
                              <td class="text-center align-middle p-1">{{ Number(accidentIncident?.loss?.hm_cost)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                            </tr>
                            <tr>
                              <td class="text-center align-middle p-1">{{ accidentIncident?.loss?.hm_currency_code === 'USD' ? '' : 'CONVERTED TO' }} USD</td>
                              <td class="text-center align-middle p-1">
                                <span class="font-weight-bold">{{ Number(accidentIncident?.loss?.hm_cost_to_usd)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                              </td>
                            </tr>
                          </table>
                        </template>
                        <template v-else>
                          0
                        </template>
                      </td>
                      <td class="text-center align-middle p-1">
                        <template v-if="accidentIncident?.loss?.cd_cost">
                          <template v-if="accidentIncident?.loss?.cd_currency_code === 'USD'">
                            {{ accidentIncident?.loss?.cd_currency_code }}: <span class="font-weight-bold">{{ Number(accidentIncident?.loss?.cd_cost)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                          </template>
                          <table class="table mb-2" v-else>
                            <tr>
                              <td class="text-center align-middle p-1">{{ accidentIncident?.loss?.cd_currency_code }}</td>
                              <td class="text-center align-middle p-1">{{ Number(accidentIncident?.loss?.cd_cost)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                            </tr>
                            <tr>
                              <td class="text-center align-middle p-1">{{ accidentIncident?.loss?.cd_currency_code === 'USD' ? '' : 'CONVERTED TO' }} USD</td>
                              <td class="text-center align-middle p-1">
                                <span class="font-weight-bold">{{ Number(accidentIncident?.loss?.cd_cost_to_usd)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                              </td>
                            </tr>
                          </table>
                        </template>
                        <template v-else>
                          0
                        </template>
                      </td>
                      <td class="text-center align-middle p-1">
                        <template v-if="accidentIncident?.loss?.e_cost">
                          <template v-if="accidentIncident?.loss?.e_currency_code === 'USD'">
                            {{ accidentIncident?.loss?.e_currency_code }}: <span class="font-weight-bold">{{ Number(accidentIncident?.loss?.e_cost)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                          </template>
                          <table class="table mb-2" v-else>
                            <tr>
                              <td class="text-center align-middle p-1">{{ accidentIncident?.loss?.e_currency_code }}</td>
                              <td class="text-center align-middle p-1">{{ Number(accidentIncident?.loss?.e_cost)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                            </tr>
                            <tr>
                              <td class="text-center align-middle p-1">{{ accidentIncident?.loss?.e_currency_code === 'USD' ? '' : 'CONVERTED TO' }} USD</td>
                              <td class="text-center align-middle p-1">
                                <span class="font-weight-bold">{{ Number(accidentIncident?.loss?.e_cost_to_usd)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                              </td>
                            </tr>
                          </table>
                        </template>
                        <template v-else>
                          0
                        </template>
                      </td>
                      <td class="text-center align-middle p-1">
                        <template v-if="accidentIncident?.loss?.tp_cost">
                          <template v-if="accidentIncident?.loss?.tp_currency_code === 'USD'">
                            {{ accidentIncident?.loss?.tp_currency_code }}: <span class="font-weight-bold">{{ Number(accidentIncident?.loss?.tp_cost)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                          </template>
                          <table class="table mb-2" v-else>
                            <tr>
                              <td class="text-center align-middle p-1">{{ accidentIncident?.loss?.tp_currency_code }}</td>
                              <td class="text-center align-middle p-1">{{ Number(accidentIncident?.loss?.tp_cost)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                            </tr>
                            <tr>
                              <td class="text-center align-middle p-1">{{ accidentIncident?.loss?.tp_currency_code === 'USD' ? '' : 'CONVERTED TO' }} USD</td>
                              <td class="text-center align-middle p-1">
                                <span class="font-weight-bold">{{ Number(accidentIncident?.loss?.tp_cost_to_usd)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                              </td>
                            </tr>
                          </table>
                        </template>
                        <template v-else>
                          0
                        </template>
                      </td>
                      <td class="text-center align-middle p-1">
                        <span class="font-weight-bold">{{ Number(accidentIncident?.loss?.total_loss_to_usd)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                      </td>
                      <td class="text-center align-middle p-0">
                        <button class="e-btn e-btn-blue e-btn-sm e-text-white"
                                v-if="isAllowed('menu.reports.accident-incident') === true"
                                @click="showReportNewTab(accidentIncident.id)"
                        >
                          <font-awesome-icon icon="eye" />
                          View
                        </button>
                      </td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.e-tbl thead tr th, .e-tbl thead tr td {
  border: 2px solid #b1b1b1;
}

.tr.hr-line , td.hr-line{
  border-bottom: 2px solid black;
}
</style>
